import { render, staticRenderFns } from "./ApparatusCard.vue?vue&type=template&id=0f3eecd4&scoped=true"
import script from "./ApparatusCard.vue?vue&type=script&lang=js"
export * from "./ApparatusCard.vue?vue&type=script&lang=js"
import style0 from "./ApparatusCard.vue?vue&type=style&index=0&id=0f3eecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3eecd4",
  null
  
)

export default component.exports